import * as React from 'react';

import { Doughnut, Line } from "react-chartjs-2";
//import "chartjs-plugin-doughnutlabel";
// import "chartjs-plugin-datalabels";

import ChartDataLabels from "chartjs-plugin-datalabels";


const def_labels = ["1-2", "2-3", "3-4", "4-5", "5-6", "6-7", "7-8", "8-9"]

const data = {
  datasets: [
    {
      data: [3000, 1000, 500, 300, 200],
      backgroundColor: [
        "rgb(242,165,152)",
        "rgb(255,232,157)",
        "rgb(236,107,109)",
        "rgb(122,231,125)",
        "rgb(195,233,151)",
        "#ffc632",
        "#2379de",
        "#711320"
      ],
      hoverBackgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
    },
  ],

  plugins: {
    labels: {
      render: "percentage",
      fontColor: ["green", "white", "red"],
      precision: 2,
    },
  },
  text: "23%",
};

var getTotal = function (myDoughnutChart) {
  var sum = myDoughnutChart.config.data.datasets[0].data.reduce(
    (a, b) => a + b,
    0
  );
  return `${sum}`;
};

function DonutWithText(props){

    const {dataset, labels, title } = props;


    if(!dataset) return null;

    data.datasets[0].data = dataset;

    if(!labels) data.labels = def_labels.slice(0,dataset.length);

    if(labels) data.labels = labels;

    return (
      <div className="row row-order-list ls-orders">
      <h2 style={{ textAlign: "center", padding: '15px' }}>{title}</h2>
      <div className="col-md-6">
        <Doughnut
          data={data}
          options={{
            cutoutPercentage: 60,
            legend: {
              display: true,
            },
            plugins: {
              doughnutlabel: {
                labels: [
                  {
                    text: getTotal,
                    font: {
                      size: "40",
                    },
                    color: "black",
                  },
                ],
              },
              ChartDataLabels,
              datalabels: {
                display: true,
                color: "black",
                font: {
                  size: 14,
                  weight: "bold",
                },
              },
            },
          }}
        />
      </div>
      <div  className="col-md-6">
        <Line
          data={data}
          options={{
            cutoutPercentage: 60,
            legend: {
              display: false,
            },
            plugins: {
              doughnutlabel: {
                labels: [
                  {
                    text: getTotal,
                    font: {
                      size: "40",
                    },
                    color: "black",
                  },
                ],
              },
              ChartDataLabels,
              datalabels: {
                display: true,
                color: "black",
                font: {
                  size: 14,
                  weight: "bold",
                },
              },
            },
          }}
        />
      </div>

      </div>
    );
  }

export default DonutWithText;
